<mat-form-field class="{{ matFormFieldClass }}" [appearance]="appearance">
  <mat-label>{{ formItem.label }}</mat-label>
  <mat-select
    [disabled]="formItem?.isDisabled || !formItem.isEditable"
    [compareWith]="compareWith"
    [multiple]="multiple"
    [placeholder]="formItem.placeholder || formItem.label || label"
    [formControl]="formControl"
    (selectionChange)="onSelectionChange($event)"
    #matSelectComponent
  >
    @if (selectUnselectAllFields) {
      <mat-option disabled="disabled" class="form-option-select-unselect-all">
        <button mat-button class="mat-primary fill text-sm" (click)="selectAll()">
          {{ 'BITF.LABEL.SELECT_ALL' | translate }}
        </button>
        <button mat-button class="mat-accent fill text-sm" (click)="deselectAll()">
          {{ 'BITF.LABEL.UNSELECT_ALL' | translate }}
        </button>
      </mat-option>
    }

    <!-- Grouped -->
    @if (formItem.isGrouped) {
      @for (group of formItem.options; track group) {
        <mat-optgroup [label]="group.label">
          @for (option of group.options; track option) {
            <mat-option
              [value]="useObject ? option : option?.id"
              [matTooltip]="option.label.length > 20 ? option.label : ''"
            >
              <div class="d-flex align-items-center">
                <span>{{ option?.label }}</span>
                @if (option.metaData?.isDeleted) {
                  <span class="icon ml-auto mr-0 c-warm"></span>
                }
              </div>
            </mat-option>
          }
        </mat-optgroup>
      }
    }

    <!-- Default -->
    @if (!formItem.isGrouped) {
      @for (option of formItem.options; track option) {
        <mat-option
          [value]="useObject ? option : option?.id"
          [matTooltip]="option.label.length > 20 ? option.label : ''"
        >
          <div class="d-flex align-items-center">
            <span>{{ option?.label }}</span>
            @if (option.metaData?.isDeleted) {
              <span class="icon ml-auto mr-0 c-warm"></span>
            }
          </div>
        </mat-option>
      }
    }
  </mat-select>
</mat-form-field>
